/**
 * Created by Jew on 2/23/2018.
 */
import { Directive} from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidatorFn, Validator, FormControl } from '@angular/forms';


// validation function
export function validateTinFactory(): ValidatorFn {
   return (c: AbstractControl) => {
      const isValid = c.value !== null && c.value !== undefined;
      if (isValid) {
         let sum = 0;
         for (let i = 0; i < 12; i++) {
            sum += parseInt(c.value.charAt(i), 10) * (13 - i);
         }
         const n = (11 - sum % 11) % 10;
         if (n === parseInt(c.value.charAt(12), 10)) {
            return null;
         } else {
            return {
               validTin: {
                  valid: false
               }
            };
         }
      }
   };
}


@Directive({
   selector: '[app-validateTin][ngModel]',
   providers: [
      { provide: NG_VALIDATORS, useExisting: ValidatorTinDirective, multi: true }
   ]
})
export class ValidatorTinDirective implements Validator {
   validator: ValidatorFn;

   constructor() {
      this.validator = validateTinFactory();
   }

   validate(c: FormControl) {
      return this.validator(c);
   }

}
